<atl-ngb-modal-header
  atlWindowInnerHeight
  (isTablet)="setIsTablet($event)"
  class="configure-builder-modal__header"
  [title]="!noStandartDeliveryProduct ? 'Title.Product_details' : noStandartDeliveryProduct.title"
  (closeModalEvent)="closeModal()"
  [isClient]="true"
></atl-ngb-modal-header>

<div *ngIf="product || noStandartDeliveryProduct" class="d-flex product v-scrollbar">
  <div class="flex-1 product__gallery">
    <ng-container *ngIf="product && !noStandartDeliveryProduct; else noStandartImage">
      
      <ng-container *ngIf="product.imagesAttributes.length; else noImage">
        <atl-image-slider
          #atlImageSliderComponent
          class="images-slider"
          [images]="product.imagesAttributes"
          [config]="imageSliderOptions"
          (afterInitSwiper)="afterInitSwiperHandler()"
        >
          <ng-container ngProjectAs="footer">
            <atl-slider-gallery-view
              class="element--hidden p-16"
              [centered]="isTablet"
              [withDetectChanges]="false"
              [images]="product.imagesAttributes"
              [activeIndex]="atlImageSliderComponent.swiperInstance?.realIndex || 0"
              [swiperInstance]="atlImageSliderComponent.afterInitSwiper | async"
            />
          </ng-container>
        </atl-image-slider>
      </ng-container>
    </ng-container>
  </div>

  <div class="flex-1 v-scrollbar product__right">
    <div *ngIf="!noStandartDeliveryProduct; else noStandartDetails" class="product__details">
      <div class="p-24">
        <h3 class="fz-24 lh-32 fw-500">{{ product.title | truncate: 100 }}</h3>
        <p class="fz-16 lh-24 mt-8" *ngIf="type && product.type?.title && type?.quantity !== undefined">
          {{
            product.type.title + ' · ' +
            type?.quantity + ' ' +
            ((type?.quantity === 1 ? 'Shared.Entity.Item_included' : 'Shared.Entity.Items_included') | translate)
          }}
        </p>

        <ng-container *ngIf="product.type">
          <p class="text-black-810 mt-8 lh-24 fz-16">
            {{ product.type.title }}
           <span *ngIf="product.productProducer?.name">
            · {{ product.productProducer?.name }}
           </span>
        </p>
        </ng-container>

        <p class="fz-16 lh-24 mt-8">

          <ng-container *ngIf="(!designLines || optionDesignLineProducts); else designLinesPrice">
            {{
              product.standard
                ? ('Shared.Title.Included' | translate) +
                  (showPrices ? ' · ' + (product.price | customDecimal) + ',-' : '')
                : product.price !== 0
                  ? ('Shared.Entity.Option' | translate) +
                    (showPrices ? ' · ' + (product.price | customDecimal) + ',-' : '')
                  : ('Title.Cost_free_option' | translate) + (showPrices ? ' · 0,-' : '')
            }}
          </ng-container>
          <span *ngIf="type?.wishlistItemExtraAmount" class="fz-16 lh-24">({{ type.wishlistItemExtraAmount }} {{ 'Title.Extra' | translate }})</span>
          <ng-template #designLinesPrice>
            <span class="white-space-nowrap">
              {{'Title.Cost_free_option' | translate}} · 0,-
            </span>

          </ng-template>
        </p>
        <div class="mt-16">
          <atl-shadow-dom-content class="product-description fz-16 lh-24">
            <span [innerHTML]="product.description || '' | removeNbsp | safeHtml"></span>
          </atl-shadow-dom-content>
        </div>
        <div class="mt-24 d-flex flex-wrap" *ngIf="product.fileResourcesAttributes.length">
          <atl-newest-document-card
            class="mr-8 mt-8"
            *ngFor="let document of product.fileResourcesAttributes"
            (click)="onPreviewDocument(document)"
            [fileName]="document.name | truncate: 20"
            [fileSize]="document.fileSize"
            [fileType]="document.fileExtension"
            [downloadLink]="document.fileName?.downloadUrl"
            [hasRemove]="false"
          >
          </atl-newest-document-card>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #noImage>
   <div class="product__no-images d-flex align-items-center justify-content-center">
    <img src="assets/empty-image-icon.svg" class="filter-icon-gray-902" alt="no images">
   </div>
</ng-template>

<ng-template #noStandartDetails>
  <div class="fz-20 fw-500 lh-24 mt-24 ml-48">
    {{ 'Title.I_do_not_want' | translate }} {{ noStandartDeliveryProduct?.productTypeName }}

    <div class="no-included-info-box mt-12">
      <img src="/assets/info-icon-v3.svg" alt="icon" class="mr-8 mt-4" />
      <span>
        <span class="fw-500 lh-24 fz-16">{{ noStandartDeliveryProduct?.productTypeName }} </span>
        <span class="fw-400 lh-24 fz-16">{{
          'Description.No_included_option' | translate: { VALUE: noStandartDeliveryProduct?.productTypeName }
        }}</span>
      </span>
    </div>
  </div>
</ng-template>

<ng-template #noStandartImage>
  <img class="no-standart" src="/assets/cancel-icon.svg" alt="preview">
</ng-template>
